import { Injectable } from '@angular/core';
import { Cordova, IonicNativePlugin, Plugin } from '@ionic-native/core';

export type Worldpay3dsEnvironment = 'staging' | 'production';

export interface IWorldpay3dsSetupOptions {
  // Cardinal device data collection JWT from the Worldpay stage-1 order response (pspAction.jwt).
  jwt: string;
  environment: Worldpay3dsEnvironment;
}

export interface IWorldpay3dsChallengeOptions {
  // Worldpay challenge reference (stage-2 pspAction.reference) - Cardinal's transactionId.
  transactionId: string;
  // Worldpay challenge payload (stage-2 pspAction.payload) - the base64 CReq.
  payload: string;
}


export type Worldpay3dsActionCode = 'SUCCESS' | 'NOACTION' | 'FAILURE' | 'ERROR' | 'CANCEL' | 'TIMEOUT';

export interface IWorldpay3dsChallengeResult {
  actionCode: Worldpay3dsActionCode;
  errorNumber?: number;
  errorDescription?: string;
}

@Plugin({
  pluginName: 'Worldpay3dsPlugin',
  plugin: 'cordova-plugin-worldpay-3ds',
  pluginRef: 'Worldpay3dsPlugin',
  platforms: ['Android', 'iOS'],
})
@Injectable()
export class Worldpay3dsPlugin extends IonicNativePlugin {

  // Resolves the consumerSessionId (Worldpay collectionReference).
  @Cordova({ otherPromise: true })
  setup(_opts: IWorldpay3dsSetupOptions): Promise<string> {
    return;
  }

  @Cordova({ otherPromise: true })
  continueChallenge(_opts: IWorldpay3dsChallengeOptions): Promise<IWorldpay3dsChallengeResult> {
    return;
  }

  @Cordova({ otherPromise: true })
  cleanup(): Promise<void> {
    return;
  }
}



// WEBPACK FOOTER //
// ./src/providers/worldpay/worldpay-3ds-sdk.ts